import React, { FC } from 'react';
import { TypeProduct } from '@/core/generated-types';
import { getShopifyProductId } from '@/utils/getShopifyProductId';
import classNames from 'classnames';
import styles from '@/components/ui/YotpoReviewStars/YotpoReviewStars.module.scss';

interface YotpoReviewsWidgetProps {
  product?: TypeProduct;
  productID?: string | null;
}

export const YotpoReviewsWidget: FC<YotpoReviewsWidgetProps> = ({
  product,
  productID,
}) => {
  /*
    The Yotpo script loading and subsequent DOM update take place
    in a custom hook called in the parent layout component.
  */

  const shopifyProductId = product ? getShopifyProductId(product) : productID;

  return shopifyProductId ? (
    <section
      className={classNames('yotpo yotpo-main-widget container', styles.root)}
      data-product-id={shopifyProductId}
    />
  ) : null;
};
